module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/icon_title_leaf-d22d76622376e2a7e30983eed9155c28.svg";